export const en = {
  // Header
  logout: "Logout",
  status_open: "Open",
  status_waitlist: "Waitlist",
  status_closed: "Closed",

  // Navigation
  nav_profile: "Profile",
  nav_portfolio: "Portfolio",
  nav_commissions: "My Commissions",
  nav_finances: "Finances",
  nav_reviews: "Reviews",
  nav_settings: "Settings",
  nav_section_commissions: "Commissions",
  nav_section_settings: "Settings",

  // Profile
  welcome_message: "Welcome, {name}!",
  profile_subtitle: "Manage how clients see you on Studiocomm",
  profile_picture: "Profile Picture",
  profile_picture_hint:
    "This image will appear on your artist card and profile. Use a square image for best results.",
  upload_photo: "Upload Photo",
  uploading: "Uploading...",
  basic_info: "Basic Information",
  avg_delivery: "Average Delivery (days)",
  your_price_range: "Your price range",
  price_range_auto: "Based on your pricing tiers",
  no_prices_yet: "Add pricing tiers to show your price range",
  specializations: "Specializations",
  specializations_hint: "What kind of art do you create? (VTuber, Emotes, Concept Art, etc.)",
  commission_status: "Commission Status",
  status_hint: 'When "Waitlist", clients can sign up to be notified when you\'re open again.',
  language_pref: "Language Preference",
  language_hint: "Select your preferred language for the dashboard and Komiko translations",
  pricing_tiers: "Pricing Tiers",
  pricing_hint: "Add your service tiers and prices",
  add_tier: "+ Add Price Tier",
  additional_fees: "Additional Fees",
  additional_fees_hint: "Set extra charges and choose which ones to show on your profile",
  fee_show: "Show",
  fee_background_simple: "Simple Background",
  fee_background_complex: "Complex Background",
  fee_extra_character: "Extra Character",
  fee_complex_design: "Complex Design",
  fee_nsfw_content: "NSFW Content",
  fee_commercial_use: "Commercial Use",
  fee_rush_order: "Rush Order",
  fee_custom: "Custom",
  fee_ask: "Ask",
  fee_dont_do: "Won't do",
  social_links: "Social Links",
  content_level: "Content Maturity",
  content_level_hint: "What type of content do you accept?",
  nsfw_level_nsfw: "NSFW",
  nsfw_level_suggestive: "Suggestive",
  nsfw_level_safe: "Safe Only",
  will_draw: "Themes I Like",
  will_draw_hint: "What themes do you enjoy drawing? (OCs, Fantasy, Sci-Fi, etc.) Max 8.",
  wont_draw: "Won't Draw (Optional)",
  wont_draw_hint: "Anything you prefer not to draw? This helps set expectations. Max 8.",
  add_custom_tag: "Add custom tag",
  custom_tag_placeholder: "Type and press Enter",
  max_tags_reached: "Maximum tags reached",
  quick_add_click: "Quick add (click to toggle):",
  or_add_custom: "Or add custom:",
  selected_tags: "Selected:",
  save_changes: "Save Changes",
  saving: "Saving...",
  profile_saved: "Profile saved successfully!",
  save_success: "Saved successfully!",
  upload_success: "Photo uploaded successfully!",

  // Portfolio
  portfolio_title: "Portfolio",
  portfolio_subtitle: "Showcase your best work to attract clients",
  your_portfolio: "Your Portfolio",
  portfolio_hint: "Drag images to reorder. The first image will be your profile image.",
  portfolio_proportion_note:
    "For best display on the main page, use a horizontal (16:9) image as your first/cover image.",
  portfolio_tags_notice:
    "Click on any artwork to add tags! Tags help clients find your work when filtering by specialization.",
  drag_drop: "Drag & drop images here to add to your portfolio",
  or_browse: "or",
  browse_files: "browse files",
  max_size: "JPG, PNG, WebP, GIF accepted. Large images auto-compressed.",
  of: "of",
  upload_complete: "Upload complete!",
  no_images: "No images yet. Upload your first artwork!",
  delete_confirm: "Delete this image? This cannot be undone.",
  image_deleted: "Image deleted",
  images: "images",

  // Settings
  settings_title: "Settings",
  settings_subtitle: "Configure your account preferences",
  account: "Account",
  change_email: "Change Email",
  new_email: "New Email",
  new_email_placeholder: "Enter new email address",
  update_email: "Update Email",
  updating: "Updating...",
  email_updated: "Email updated! Please log in with your new email.",
  email_update_failed: "Failed to update email",
  change_password: "Change Password",
  new_password: "New Password",
  confirm_password: "Confirm New Password",
  password_placeholder: "Enter password",
  update_password: "Update Password",
  password_updated: "Password updated successfully!",
  password_update_failed: "Failed to update password",
  passwords_dont_match: "Passwords do not match",
  password_too_short: "Password must be at least 6 characters",
  danger_zone: "Danger Zone",
  danger_hint: "These actions are irreversible",
  delete_account: "Delete Account",

  // Coming soon
  coming_soon: "Coming Soon",

  // Portfolio tags
  edit_tags: "Edit Tags",
  select_tags: "Select Tags",
  select_tags_hint: "Choose which specializations apply to this artwork",
  no_specializations: "Please add specializations in your profile first to tag your artwork.",
  cancel: "Cancel",
  save: "Save",
  tags_saved: "Tags saved!",
  tags_saved_error: "Failed to save tags",
  alt_text_label: "Alt Text (Accessibility)",
  alt_text_hint: "Describe the image for screen readers and SEO",
  alt_text_placeholder: "E.g., Character portrait with blue hair in fantasy armor",
  generate_alt: "Generate",
  generate_alt_tooltip: "Auto-generate alt text using AI",
  generating_alt: "Generating...",
  alt_generated: "Alt text generated!",
  alt_generate_error: "Failed to generate alt text",

  // Cover
  cover_title: "Cover Image",
  cover_hint: "The banner at the top of your artist page. Pick an image and frame it for every screen size.",
  edit_banner: "Edit banner",
  crop_cover: "Crop Cover",
  apply_crop: "Apply Crop",

  // Content rating
  content_rating: "Content Rating",
  commissioner: "Commissioner",
  commissioner_placeholder: "Enter commissioner name",
} as const;

export type TranslationKey = keyof typeof en;
